import { useNavHeightContext } from 'common/contexts/NavHeightContext';
import * as React from 'react';

interface Props {
  children: React.ReactNode;
  className?: string;
}

/**
 * Renders a div that fills the entire space of the settings
 * area for new settings pages
 */
export const SettingsPage: React.FC<Props> = (props) => {
  const { children, className } = props;
  const { marginTop } = useNavHeightContext();

  return (
    <div
      style={{
        height: `calc(100vh - ${marginTop}px)`,
      }}
      className={`bg-white w-full pt-8 overflow-scroll ${className}`}
    >
      {children}
    </div>
  );
};
SettingsPage.displayName = 'SettingsPage';
